const resources = {
    new: 'Nouveauté'
};

module.exports = function getResource(label) {
    return resources[label];
};
